import React from "./react.shim";
import {createSinglePromise,getTnsSdkCacheGroup,debugLog} from "../utils/loadResources";
type ComponentLoaderProps = {
    providerPackage: string;
    providerEntry: string;
    // providerVersion?: string;
} & {
    [key: string]: any;
}
type ComponentLoaderState = {
    currProviderPackage:string,
    currProviderEntry:string,
    loading: boolean;
    component: any;
    errorMsg: string;
    hasError: boolean;
}

// 加载组件缓存组
const cacheLoadComponents = getTnsSdkCacheGroup('loadComponents');
/**
 * 异步组件加载器
 */
let g_oid = 0; // 实例计数器
class ComponentLoader extends React.Component<ComponentLoaderProps, ComponentLoaderState> {
    private cacheId:string = '';
    private oid?:number;
    private providerPackage?:string;
    private providerEntry?:string;
    private isPreferIndependent?:boolean;// 是否优先独立入口加载
    private loadPromise:Record<string, Promise<any>> = {};

    constructor(props:ComponentLoaderProps) {
        super(props);
        const { providerPackage, providerEntry, isPreferIndependent } = props;
        this.oid = g_oid = g_oid + 1;
        this.providerPackage = providerPackage;
        this.providerEntry = providerEntry;
        this.isPreferIndependent = isPreferIndependent;
        this.cacheId = this.providerPackage+"!"+this.providerEntry;
        this.state = {
            component: cacheLoadComponents[this.cacheId] || null,
            // component:null,
            hasError:false,
            // loading:false,
            loading: !cacheLoadComponents[this.cacheId],
            errorMsg: ''
        };
        this.mountModule.bind(this);
        debugLog('AAA--__tnsSdk_cache_components__->',cacheLoadComponents)
    }

    // 子树渲染异常后进行UI降级避免页面奔溃白屏
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const { providerPackage, providerEntry } = this.props;
        console.log('%c', 'color: MidnightBlue; background: Aquamarine; font-size: 20px;', `${providerPackage}->${providerEntry}组件渲染报错` , error, errorInfo);
    }

    componentWillMount(){
        if(!this.state.component){
            this.mountModule().then(()=>{debugLog('AAA----ComponentLoader-->mountModule---finish')});//.catch((err)=>{console.error('AAA----ComponentLoader-->mountModule---error',err)});
        }else{
            debugLog(`[TNE]--->ComponentLoader 复用装载-->[${this.oid}]${this.cacheId}`);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: ComponentLoaderProps): void {
        if((nextProps.providerPackage !== this.props.providerPackage)
            || (nextProps.providerEntry !== this.props.providerEntry)){
            debugLog(`[TNE]--->ComponentLoader 发生变更-->[${this.oid}]${this.cacheId}`);
            this.providerPackage = nextProps.providerPackage;
            this.providerEntry = nextProps.providerEntry;
            this.cacheId = nextProps.providerPackage+"!"+nextProps.providerEntry;
            this.mountModule().then(()=>{debugLog('AAA----ComponentLoader-->mountModule-change---finish')});//.catch((err)=>{console.error('AAA----ComponentLoader-->mountModule-change---error',err)});
        }
    }

    async mountModule() {
        if (!this.providerPackage) {
            console.error(`加载失败，缺少二方包名`);
            // 渲染为空
            this.setState({loading: false,hasError: false,errorMsg: '',component: null});
            return;
        }
        try {
            debugLog(`[TNE]--->ComponentLoader 开始装载-->[${this.oid}]${this.cacheId}`);
            if (!this.loadPromise[this.cacheId]) {
                this.loadPromise[this.cacheId] = createSinglePromise(
                    "ComponentLoader.asyncLoadComponent." +
                        this.providerPackage +
                        "." +
                        this.providerEntry,
                    () =>
                        window.tnsSdk.asyncLoadComponent(
                            this.providerPackage,
                            this.providerEntry,
                            this.isPreferIndependent
                        )
                );
            }
            if((this.loadPromise[this.cacheId] as Promise<any>).then){
                debugLog(`[TNE]--->ComponentLoader 开始装载--has then->[${this.oid}]${this.cacheId}`);
            }else{
                debugLog(`[TNE]--->ComponentLoader 开始装载--no then->[${this.oid}]${this.cacheId}`);
            }
            cacheLoadComponents[this.cacheId] = false;
            const remoteComponent = await this.loadPromise[this.cacheId]; // 缓存中取不到组件再重promise中获取
            if(remoteComponent) {
                debugLog(`[TNE]--->ComponentLoader 装载完毕-->[${this.oid}]【${this.cacheId}】${remoteComponent?'存在':'不存在'}`);
                cacheLoadComponents[this.cacheId] = remoteComponent;
                this.setState({loading: false, hasError: false, errorMsg: '', component:cacheLoadComponents[this.cacheId]})
                // this.setState({loading: false, hasError: false, errorMsg: '', component:remoteComponent})
            }else{
                debugLog(`[TNE]--->ComponentLoader 装载失败-->[${this.oid}]【${this.cacheId}】`);
                this.setState({loading: false, hasError: true, errorMsg: `未发现组件【${this.cacheId}】`, component: null});
            }
        } catch (err) {
            debugLog(`[TNE]--->ComponentLoader 装载异常-->[${this.oid}]【${this.cacheId}】`);
            cacheLoadComponents[this.cacheId] = false;
            console.error(`%c 组件加载异常【${this.cacheId}】`,'color: MidnightBlue; background: Aquamarine; font-size: 20px;',err);
            let errorMsg = '';
            if (err instanceof Error) {
                errorMsg = err.message;
            }else if(typeof err == "string"){
                errorMsg = err;
            }
            this.setState({loading: false, hasError: true, errorMsg: errorMsg, component: null});
        }
    }

    render() {
        const { loading, hasError,errorMsg } = this.state;
        const { providerPackage, providerEntry, forwardedRef, showError = true, ...otherProps } = this.props;
        const ViewComponent = this.state.component;
        if(typeof cacheLoadComponents[this.cacheId] === "object"){
            debugLog(`[TNE]--->ComponentLoader 获取【${providerPackage}!${providerEntry}】为 [object] 类型，React渲染组件会有问题，请联系业务开发排查!`)
        }
        if(ViewComponent){
            debugLog(`[TNE]--->ComponentLoader 执行渲染--->[${this.oid}]${this.cacheId}\n`,this.state);
        }else{
            // debugLog(`AAA--->ComponentLoader 执行渲染--->[${this.oid}]${this.cacheId} 空`);
        }
        return loading ? null : hasError ? (
            (showError ? <span>{errorMsg}</span> : null)
        ) : ViewComponent ? (
            <ViewComponent ref={forwardedRef} {...otherProps} />
        ) : null;
    }
}

// 转发ref
const ComponentLoaderForwardRef = React.forwardRef((props, ref) => {
    return <ComponentLoader forwardedRef={ref} {...props} />;
});
// 兼容tnsSdk.js放在React之前的情况，处理React.forwardRef不存在的情况
const NewComponentLoader =
    typeof React.forwardRef === "function" ? ComponentLoaderForwardRef : ComponentLoader;
export default NewComponentLoader;